import { async } from "@firebase/util";
import { useDispatch } from "react-redux";
import { signUpStart } from "../../../store/user/user.action";
import { useState, useContext } from "react";
import { createAuthUserWithEmailAndPassword, createUserDocumentFromAuth } from "../../../utils/firebase/firebase.util";
import FormInput from "../../form-input/form-input.component";
import './sign-up-form-style.scss'
import Button from "../../button/button.component";
import { useSelector } from "react-redux";
// import { setCurrentUser } from "../../../store/user/user.action";
// import { UserContext } from "../../../contexts/user.context";

const defaultFormFields={
    displayName:'',
    email:'',
    password:'',
    confirmPassword:''
}

const SignUpForm=()=>{
    const [formFields,setFormFields]=useState(defaultFormFields)
    const {displayName,email,password,confirmPassword}=formFields
    const dispatch=useDispatch()

    // const  setCurrentUser=useSelector(setCurrentUser)

    const resetFormFields=()=>{
        setFormFields(defaultFormFields)
    }
    

    const handleChange=(event)=>{
        const {name,value}=event.target;
        setFormFields({...formFields,[name]:value})


    };
    const handleSubmit=async(event)=>{
        event.preventDefault();
        if(password !== confirmPassword){
            alert("Password do not match")
            return;
        }
        try{
            dispatch(signUpStart(email, password, displayName))
            // const {user}= await createAuthUserWithEmailAndPassword(email,password)
           
            // await createUserDocumentFromAuth(user,{displayName})
            
            resetFormFields();
        }catch(error){
            if(error.code ==='auth/email-already-in-use'){
                alert('User Email already Exits')
            }else{

                console.log('====================================');
            console.log(error);
            console.log('====================================');
            }
            
        }


    }


    return (
        <div className="sign-up-container">
            <h2>Don't Have an account</h2>
            <span>Sign up with your Email and Password</span>
            <form onSubmit={handleSubmit}>
                
                <FormInput label='Display Name' type='text' required onChange={handleChange} name='displayName' value={displayName} />
                
                <FormInput label='Email' type='email' required onChange={handleChange} name='email' value={email} />
               
                <FormInput label='password' type='password' required onChange={handleChange} name='password' value={password} />
                
                <FormInput label='Confirm password' type='password' required onChange={handleChange} name='confirmPassword' value={confirmPassword} />
                <Button buttonType='inverted' type='submit'>Sign Up</Button>
            </form>
        </div>
    )
}
export default SignUpForm;